import { memo } from 'react';
import SVGIconBase from './SVGIconBase';
import { jsx as _jsx } from "react/jsx-runtime";
const PlusIcon = /*#__PURE__*/memo(() => /*#__PURE__*/_jsx(SVGIconBase, {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    d: "M.8071 6.7687H5.2339V11.2194C5.2339 11.6506 5.5833 12 6.0145 12 6.4458 12 6.7952 11.6506 6.7952 11.2194V6.7925H11.222C11.6533 6.7925 12.0026 6.4432 12.0026 6.0119 12.0026 5.5806 11.6533 5.2313 11.222 5.2313H6.7952V.7806C6.7952.3494 6.4458 0 6.0145 0 5.5833 0 5.2339.3494 5.2339.7806V5.2075H.8071C.3758 5.2075.0264 5.5568.0264 5.9881.0264 6.4194.3758 6.7687.8071 6.7687Z"
  })
}));
PlusIcon.displayName = 'PlusIcon';
export default PlusIcon;